import { Card } from "reactstrap";

const EvaluationCard = ({
  children,
  className = "",
  style = {},
  title,
  subtitle,
}) => {
  return (
    <Card
      className={`shadow-sm border rounded-4 p-4 bg-white w-100 ${className}`}
      style={{
        borderColor: "#eef2f6",
        ...style,
      }}
    >
      {title && (
        <div className="mb-4 text-start">
          <h5 className="fw-bold text-dark mb-1" style={{ fontSize: "18px" }}>
            {title}
          </h5>
          {subtitle && (
            <div className="text-muted" style={{ fontSize: "13px" }}>
              {subtitle}
            </div>
          )}
        </div>
      )}
      {children}
    </Card>
  );
};

export default EvaluationCard;
